import { FilePdf } from '@phosphor-icons/react';
import React from 'react';

import { Link } from '@components';

import * as Estilos from './styles';

interface BuscaPorTextoProps {
  data: string;
  descricao: string;
  pagina: number;
  nomeArquivo: string;
  ocorrencia: string;
  textos: string[];
  endereco: string;
}

export const BuscaPorTexto: React.FC<BuscaPorTextoProps> = ({
  data,
  descricao,
  pagina,
  nomeArquivo,
  ocorrencia,
  textos,
  endereco,
}: BuscaPorTextoProps) => {
  return (
    <Estilos.Container>
      {data} - <span>{descricao}</span> <br />
      <span>Página: {pagina} -</span> <span className='marcacao'>{ocorrencia} ocorrência</span>{' '}
      <br />
      {textos?.map((texto, index) => (
        <div key={index} className='texto' dangerouslySetInnerHTML={{ __html: texto }}></div>
      ))}
      <Estilos.Linha>
        <Link
          endereco={`/api/diarios/baixar-pagina/?${new URLSearchParams({
            nomeArquivo: nomeArquivo.toString(),
            pagina: pagina.toString(),
          })}`}
          titulo={`Abrir página ${pagina}`}
          Icone={FilePdf}
          abertura='_blank'
          rel='noreferrer noopener'
        />
        <Link endereco={endereco} titulo='Abrir diário completo' Icone={FilePdf} />
      </Estilos.Linha>
    </Estilos.Container>
  );
};
